import { NgStyle } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { IpoTranslatePipe, LoadingState } from '@ip-only/front-end-library';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { RP_INNER_DUCT_OPENED } from '../../../../../shared/posthug-analytics/analytics-event-types';
import { AnalyticsService } from '../../../../../shared/posthug-analytics/analytics.service';
import { DuctService } from '../../../../service/map/duct/duct.service';
import { Duct } from '../../../../span-progress-entities';
import { DuctContentComponent } from '../duct-content.component';

@Component({
  selector: 'app-span-duct',
  template: `
    <app-duct-content
      [ductsMissing]="ductsMissing"
      [isLoading]="ductsLoadingState.isLoading"
    >
      <div class="duct-header">
        <strong>{{ 'duct.header' | translate }}</strong>
        @if (!ductsMissing) {
          <div class="toggle-subducts" (click)="toggleShowSubducts()">
            <strong>(</strong>
            <strong class="toggle-subducts-text">{{
              (showSubducts ? 'duct.hideSubducts' : 'duct.showSubducts')
                | translate
            }}</strong>
            <strong>)</strong>
          </div>
        }
        <strong>:</strong>
      </div>

      @for (duct of ducts; track duct) {
        <div class="duct-container">
          <div class="main-duct">
            <div class="duct" [style.background-color]="duct.colorCode"></div>
            <span [ngStyle]="{ lineHeight: 'normal' }">{{ duct.name }}</span>
          </div>
          <div class="subduct-container">
            @if (showSubducts) {
              @for (subDuct of duct.subDucts; track subDuct) {
                <div class="subduct-wrapper">
                  <div class="subduct-cables">
                    <div
                      class="duct subduct"
                      [style.background-color]="subDuct.colorCode"
                    ></div>
                    <div class="subduct-names-container">
                      <div>{{ subDuct.name }}</div>
                      @if (subDuct.cable) {
                        <div class="subduct-additional-name">
                          {{ subDuct.cable.name }}
                        </div>
                      }
                    </div>
                  </div>
                </div>
              }
            }
          </div>
        </div>
      }
    </app-duct-content>
  `,
  styleUrls: ['./span-duct.component.scss'],
  imports: [DuctContentComponent, IpoTranslatePipe, NgStyle],
})
export class SpanDuctComponent implements OnInit, OnDestroy {
  spanId = input.required<string>();

  ducts: Duct[] = [];
  ductsLoadingState: LoadingState;
  showSubducts = false;

  private readonly cancelSub$ = new Subject<void>();

  constructor(
    private readonly ductService: DuctService,
    private readonly changeDetector: ChangeDetectorRef,
    private readonly analyticsService: AnalyticsService,
  ) {}

  ngOnInit() {
    this.ductService
      .getEntityLoadingState$()
      .pipe(takeUntil(this.cancelSub$))
      .subscribe((loadingState) => {
        this.ductsLoadingState = loadingState;
        this.changeDetector.detectChanges();
      });
    this.ductService
      .getSpanDuctData$(this.spanId())
      .pipe(takeUntil(this.cancelSub$))
      .subscribe((ducts) => {
        this.ducts = ducts;
        this.changeDetector.detectChanges();
      });
  }

  ngOnDestroy() {
    this.cancelSub$.next();
  }

  toggleShowSubducts() {
    if (!this.showSubducts) {
      this.analyticsService.logEvent(RP_INNER_DUCT_OPENED);
    }
    this.showSubducts = !this.showSubducts;
    this.changeDetector.detectChanges();
  }

  get ductsMissing() {
    return this.ducts.length === 0;
  }
}
